import { render } from "./ListaMuzee.vue?vue&type=template&id=20228094"
import script from "./ListaMuzee.vue?vue&type=script&lang=js"
export * from "./ListaMuzee.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__